import replaceTenantId from "./replace-tenant-id";

function getAppTenantId (main: any) {
  const tenantId = main?.tenant?.tenantId || "";
  return replaceTenantId(tenantId);
}

export default getAppTenantId;
